import { DiscoveryBlock, DiscoveryProduct } from '@teko/discovery';
import {
  DiscoveryBlocks,
  RecentViewedProducts,
} from 'components/desktop/organisms';
import { useTenantConfig } from 'contexts';
import { findBlockByType } from 'helpers';
import { useHomePage } from 'hooks';
import dynamic from 'next/dynamic';
import React from 'react';
import { AboveTheFold, SideBanners } from './components';
import { styled } from '@teko/ds-desktop';
import { MegaMenuItemInterface } from '@teko/types/pb';
import { BlockType } from '@teko/discovery';
import { LazyComponent } from 'components/LazyComponent';

const PopupPromotion = dynamic(() =>
  import('components/PopupPromotion').then((mod) => mod.PopupPromotion),
);
const QuestionnairesModal = dynamic(
  () => import('components/QuestionnairesModal'),
);

const StyledSideBanners = styled(SideBanners)`
  top: 8px;
  > div {
    margin-top: 88px;
  }
`;
export interface DefaultHomeProps {
  serverBlocks: DiscoveryBlock[];
  menuItems?: MegaMenuItemInterface[];
  mapProducts?: { [key: string]: DiscoveryProduct[] }; // for SSR
}

export const DefaultHome: React.FC<DefaultHomeProps> = ({
  serverBlocks,
  menuItems,
  mapProducts = {},
}: DefaultHomeProps) => {
  const {
    questionnairesUrl,
    megaMenuType = 'vertical',
    isBot,
  } = useTenantConfig();

  const {
    slideBanners,
    topRightBanners,
    blocks,
    popupBanner,
    horizontalFourBanners,
  } = useHomePage(serverBlocks);

  const showPopupBanner = popupBanner && popupBanner?.cookedData?.[0];

  return (
    <>
      {showPopupBanner && !isBot && (
        <PopupPromotion banner={popupBanner.cookedData[0]} />
      )}
      <AboveTheFold
        menuItems={
          megaMenuType === 'vertical' &&
          findBlockByType(BlockType.MEGA_MENU, blocks)
            ? menuItems
            : []
        }
        slideBanners={slideBanners}
        topRightBanners={topRightBanners}
        horizontalFourBanners={horizontalFourBanners}
      />
      <StyledSideBanners />
      <DiscoveryBlocks blocks={blocks} mapProducts={mapProducts} />
      <LazyComponent>
        <RecentViewedProducts />
      </LazyComponent>
      {questionnairesUrl && !isBot && <QuestionnairesModal />}
    </>
  );
};
